import { render } from "./TableItem.vue?vue&type=template&id=c08d56ea&scoped=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=c08d56ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c08d56ea"

export default script